export default "__VITE_ASSET__1$bPP5cj__"